import { BaseTableRow, getHeaderName } from "@/types";
import { TableProps } from "@/types/components/table.types";
import { GridRowParams } from "@mui/x-data-grid";
import { SyntheticEvent } from "react";
import { Table } from "./Table";

interface JobLinkedTableRow extends BaseTableRow {
  name?: string;
  description?: string;
}

interface JobLinkedTableOwnProps<
  T extends JobLinkedTableRow = JobLinkedTableRow
> extends TableProps<T> {
  onJobClick?: (row: T, e: SyntheticEvent) => void;
}

export class JobLinkedTable<T extends JobLinkedTableRow = JobLinkedTableRow> extends Table<
  T,
  JobLinkedTableOwnProps<T>
> {
  static columns = {
    name: {
      field: "name",
      label: "tableColumns.jobDefinitions"
    },
    description: {
      field: "description",
      label: "tableColumns.description"
    },
    jobAttributes: {
      field: "jobAttributes",
      label: "tableColumns.jobAttributes"
    }
  };

  static defaultProps = {
    ...Table.defaultProps,
    noRowsMessage: "No rows, yet"
  };

  constructor(props: JobLinkedTableOwnProps<T>) {
    super(props);

    this.state = {
      ...this.state
    };
    this.onRowClick = this.onRowClick.bind(this);
  }

  onRowClick(params: GridRowParams, e: SyntheticEvent) {
    const { onJobClick } = this.props;
    if (onJobClick) {
      onJobClick(params.row, e);
    }
  }

  initColumns() {
    const { columns, sortable } = this.props;

    this.columns = [];

    if (!columns) return;

    columns.forEach((c) => {
      if (this.hasColumn(c)) {
        if (c.type === JobLinkedTable.columns.name)
          this.columns.push({
            field: "name",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            filterable: false,
            disableReorder: true,
            flex: 1,
            valueGetter: (_value, row) => row.name,
            renderCell: (params) => <div>{params.row.name}</div>
          });
        if (c.type === JobLinkedTable.columns.description)
          this.columns.push({
            field: "description",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            filterable: false,
            disableReorder: true,
            flex: 1,
            valueGetter: (_value, row) => row.description,
            renderCell: (params) => <div>{params.row.description}</div>
          });
        // if (c.type === JobLinkedTable.columns.jobAttributes)
        //   this.columns.push({
        //     field: "jobDefinitions",
        //     headerName: c.label || c.type.label,
        //     sortable: sortable,
        //     filterable: false,
        //     disableReorder: true,
        //     flex: 1,
        //     valueGetter: (_value: any, row: any) => row.name,
        //     cellRenderer: (params: any) => <div>{params.row.name}</div>
        //   });
      }
    });
  }
}
